<template>
  <li>
    <router-link
      :to="link"
      class="nav-link text-white hover:text-gray-200 font-medium transition-colors duration-200 px-3 py-2 rounded-md hover:bg-white/10"
      active-class="text-yellow-300 bg-white/20"
    >
      {{ label }}
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'NavItem',
    props: {
      label: {
        type: String,
        required: true,
      },
      link: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>
  /* 
    Minimal styling here. 
    The main nav styling is in .primary-nav / .secondary-nav in common.css
  */
</style>
